module.exports = __webpack_public_path__ + "img/icon_nav_msg_hover.2d529839.svg";